import React, { useState, useEffect, useContext, useLayoutEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import t from "../../Utils/Translation";
import { LykioContext } from "../routing/LykioAuthorizedRoute";
import { AUTHORIZED_URL_PREFIX, LIBRARY_URL_WITHOUT_PARAM, AxiosConfig } from '../../Utils/Constants';
import './library.css';
import Loading from '../common/Loading';
import { notify, pleaseRefreshError } from '../../Utils/Notificator';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import Units from './../home/Units';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SubCategoryModal from './SubcategoryModal';
import Footer from './../common/Footer';

const Library = () => {
	const context = useContext(LykioContext);
	const tenantProperties = context.tenantProperties;
	const [ rootCategoriesName, setRootCategoriesName ] = useState(tenantProperties && tenantProperties.rootCategoriesName);
	const [ isLoading, setIsLoading ] = useState(true);
	const [ units, setUnits ] = useState([]);
	const [ subCategories, setSubCategories ] = useState([]);
	const [ allCategories, setAllCategories] = useState([]);
	const [ stats, setStats ] = useState();
	const { categoryreference } = useParams();
	const [categoryDescription, setCategoryDescription] = useState('');
	const language = localStorage.getItem('content-i18n');
	const ref = React.createRef();
	const [ pageScrolling, setPageScrolling] = useState(false);

	const handleScreenSize = () => {
		if (ref.current.clientHeight < ref.current.scrollHeight) {
			setPageScrolling(true);
		  } else {
			  setPageScrolling(false);
		  }
	}

	useLayoutEffect(() => {
		handleScreenSize();
		window.addEventListener('resize', handleScreenSize);
		return () => {
			window.removeEventListener('resize', handleScreenSize);
		}
	}, [ref]);

	useEffect(
		() => {
			const fetchLibraryData = async () => {
				try {
					const { data } = await axios.post(
						`${AUTHORIZED_URL_PREFIX}${LIBRARY_URL_WITHOUT_PARAM}`,
						{ categoryreference, language },
						AxiosConfig()
					);
					if(data.success) {
					  setUnits(data.units);
					  setStats(data.stats);
					  setAllCategories(data.allCategories);
					  setSubCategories(data.subCategories);
					  setCategoryDescription(data.categoryDescription);
					  setIsLoading(false);
					}else{
					  notify(pleaseRefreshError);
					}
				} catch (error) {
					console.error(error);
					notify(pleaseRefreshError);
				}
			};
			fetchLibraryData();
		},
		[ categoryreference ]
	);
	return <div ref={ref} className="lykioccs-main-content lykiocss-category-bg lykioccs-category-library lykiocss-hide-footer">
			{isLoading ? <Loading /> :<React.Fragment><Container style={{marginTop:'0.5em', marginLeft:'1em !important'}}>      
					<Row>
						<Col xs={12}>
							<div style={{fontSize:'x-large'}} className="lykiocss-library-category-header">
								<h1>{t((allCategories.filter(category=> category.reference===categoryreference)[0]) && allCategories.filter(category=> category.reference===categoryreference)[0].name)}</h1>
							</div>
						</Col>
						<Col xs={12}>
							{subCategories.map(subCategory => {
								return <SubCategoryModal subCategory={subCategory} allCategories={allCategories}/>
							})
							}
						</Col>
					</Row>
			</Container>
			<div style={{marginLeft:'2em', marginBottom:'2em'}}>
				{subCategories.map(subCategory => {
					return <Units units={units.filter(unit => unit.categoryreference === subCategory.reference)} title={(allCategories.filter(category=> category.reference===subCategory.reference)[0]) && allCategories.filter(category=> category.reference===subCategory.reference)[0].name}/>
				})
				}
			</div>

			<div style={{marginLeft:'2em', marginBottom:'2em'}}>
				{units.filter(unit => unit.categoryreference === categoryreference).length>0 && 
					<Units units={units.filter(unit => unit.categoryreference === categoryreference)} title={''} />
				}
			</div>
			</React.Fragment>
			}
			<div style = { !pageScrolling ? { position:'fixed', bottom:'0' } : {position:'relative'}}>
			<Footer />
			</div>
	</div>
};

export default Library;
